<template>
  <TitledPdfWrapper
    v-if="
      dialog.content.slug.includes('brief') ||
      dialog.content.slug === 'proposal' ||
      dialog.content.slug === 'industrial-ideation'
    "
  />
  <VirtualSample v-if="dialog.content.slug === 'virtual-sample'" />
  <PhysicalSample v-if="dialog.content.slug === 'physical-sample'" />
</template>
<script setup>
import TitledPdfWrapper from "./TitledPdfWrapper.vue";
import { useDialogStore } from "../../stores/dialog";
import VirtualSample from "./virtual-sample/VirtualSample.vue";
import PhysicalSample from "./PhysicalSample.vue";

const dialog = useDialogStore();
</script>
